import React from 'react';
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {Card, CardContent, Grid} from "@mui/material";

import CustomButton from "components/CustomButton";

import {blueColor, greyishBlue500} from "assets/jss/main";
import {ReactComponent as CelebrationIcon} from "assets/img/wms/celebration.svg";

ScanFinishContent.propTypes = {
    goBackToSorting: PropTypes.func
};

function ScanFinishContent({goBackToSorting = () => {}}) {
    return (
        <Card style={{backgroundColor: 'white'}}>
            <CardContent style={{padding: '0 16px 16px 16px'}}>
                <Grid container direction={'column'} justifyContent={"center"} alignItems={'center'}>
                    <Grid item>
                        <div style={{
                            color: blueColor,
                            fontSize: '16px',
                            fontWeight: 600,
                            marginBottom: '32px',
                            marginTop: '24px',
                            textWrap: 'nowrap'
                        }}>
                            <FormattedMessage id={"wms.sorting.over.title"}/>
                        </div>
                    </Grid>
                    <Grid item>
                        <CelebrationIcon style={{maxWidth: "45px", maxHeight: "45px"}}/>
                    </Grid>
                    <Grid item style={{
                        marginBottom: '32px',
                        fontSize: '14px',
                        fontWeight: 400,
                        color: greyishBlue500
                    }}>
                        <FormattedMessage id={"wms.sorting.over.subtitle"}/>
                    </Grid>
                    <Grid item style={{width: '100%'}}>
                        <CustomButton onClick={() => goBackToSorting()} fullWidth>
                            <FormattedMessage id={"wms.sorting.over.button"}/>
                        </CustomButton>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

export default ScanFinishContent;
